module.exports = __webpack_public_path__ + "media/nohaynadie.fa301233.mp3";